module.exports = __webpack_public_path__ + "static/img/11.20d1079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/11.jpg
// module id = 7+bi
// module chunks = 0